import { createEnumApi } from '../partials/enumApi'

const payment_type = createEnumApi(
    'bt_get_payment_types',
    {
        onDataReceived: data => data.payment_types
    }
)

export default payment_type